import React from 'react';
import { IoMdDocument, IoMdPerson } from 'react-icons/io';
import { FaCamera, FaVideo } from 'react-icons/fa';
import { BsFillMicFill } from 'react-icons/bs';
import { getFileTypeName } from '../../utils';
import {
  ChatBallonResponseReply,
  ReplyContent,
  ReplyContentInfo,
  ReplyIcon,
  ReplySender,
  ReplyText,
  ReplyTextPreview,
  ReplyImagePreview,
  ReplyStickerPreview
} from '../styled';

const ReplyMessage = ({
  context,
  handleScrollToMessage,
  color,
  backgroundColor,
  textColor
}) => {
  const getReplyIcon = (type) => {
    switch (type) {
      case 'file':
        return <IoMdDocument size={12} />;
      case 'image':
        return <FaCamera size={12} />;
      case 'audio':
        return <BsFillMicFill size={12} />;
      case 'video':
        return <FaVideo size={12} />;
      case 'contact':
        return <IoMdPerson size={12} />;
      default:
        return null;
    }
  };

  return (
    context && (
      <ChatBallonResponseReply
        color={color}
        backgroundColor={backgroundColor}
        onClick={handleScrollToMessage}
      >
        <ReplyContent>
          {['file', 'image', 'audio', 'video', 'contact'].includes(
            context.response_type
          ) && (
            <ReplyContentInfo
              isFullWidth={['file', 'video', 'contact'].includes(
                context.response_type
              )}
            >
              <ReplySender textColor={textColor}>
                {context.escrita_por}
              </ReplySender>
              <div
                style={{
                  maxWidth: '100%'
                }}
              >
                <ReplyIcon>{getReplyIcon(context.response_type)}</ReplyIcon>
                <ReplyText textColor={textColor}>
                  {context.response_type === 'contact' ? (
                    <>{context.contact[0].name.formatted_name}</>
                  ) : (
                    context.description ||
                    getFileTypeName(context.response_type)
                  )}
                </ReplyText>
              </div>
            </ReplyContentInfo>
          )}
          {context.response_type === 'text' && (
            <ReplyTextPreview>
              <ReplySender>{context.escrita_por}</ReplySender>
              <ReplyText>{context.texto}</ReplyText>
            </ReplyTextPreview>
          )}
          {context.response_type === 'image' && (
            <ReplyImagePreview
              style={{ backgroundImage: `url(${context.source})` }}
            />
          )}
          {context.response_type === 'sticker' && (
            <ReplyStickerPreview
              style={{ backgroundImage: `url(${context.source})` }}
            />
          )}
        </ReplyContent>
      </ChatBallonResponseReply>
    )
  );
};

export default ReplyMessage;
